export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8023.7fb39b72.jpg";